import { applicationContext } from 'core/utils';
import { action, observable, runInAction } from 'mobx';
import * as _ from 'lodash';
import { BaasicDropdownStore, BaseEditViewStore } from 'core/stores';
import { UserCreateForm } from 'application/user/forms';

const ErrorType = {
    User: 0
};
@applicationContext
class UserCreateViewStore extends BaseEditViewStore {
    @observable accessor selectedRoles = [];

    roleMultiselectStore = null;
    titleDropdownStore = null;
    languageDropdownStore = null;
    constructor(rootStore) {
        super(rootStore, {
            name: 'user',
            id: undefined,
            actions: {
                create: async () => {
                    const userStore = rootStore.application.baasic.membershipModule.user;
                    const { roles, ... user   } = this.form.values();
                    const userRoles = _.map(roles, (r) => {
                        return {
                            name: r.name
                        }
                    });         
                    user.isApproved = true;
                    user.creationDate = new Date();
                    user.roles = userRoles;
                    user.email = user.userEmail;
                    
                    try {
                        await userStore.create(user);
                    } catch (err) {
                        this.form.invalidate(err.data);
                        throw { type: ErrorType.User, error: err };
                    }
                }
            },
            errorActions: {
                onCreateError: ({ type, error }) => {
                    switch (type) {
                        case ErrorType.User:
                            rootStore.notificationStore.error('USER.CREATE.USER_CREATE_ERROR', error);
                            break;
                        case ErrorType.Profile:
                            rootStore.notificationStore.success('USER.CREATE.PROFILE_CREATE_ERROR', error);
                            break;
                        default:
                            rootStore.notificationStore.success('EDIT_FORM_LAYOUT.ERROR_CREATE');
                            break;
                    }
                }
            },
            FormClass: UserCreateForm
        });

        this.roleMultiselectStore = new BaasicDropdownStore({
            multi: true
        });
    }

    @action.bound
    notifySuccessCreate() {
        this.rootStore.notificationStore.success('USER.CREATE.USER_CREATE_SUCCESS');
    }

    @action.bound
    async onInit({ initialLoad }) {
        if (!initialLoad) {
            this.rootStore.routerStore.goTo(
                'master.app.main.user.list'
            )
        }
        else {
            this.form.clear();
            await this.fetchRoles();
        }
    }

    @action.bound
    async fetchRoles() {
        this.roleMultiselectStore.setLoading(true);
        const response = await this.rootStore.application.baasic.membershipModule.lookups.get({ embed: 'role', rpp: 30 });

        runInAction(() => {                    
            this.roleMultiselectStore.setItems([...response.data.role].sort((a, b) => a.name > b.name ? 1 : -1, ));
            this.roleMultiselectStore.setLoading(false);
        });
    }
}

export default UserCreateViewStore;
